import script from "./LiveChat.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveChat.vue?vue&type=script&setup=true&lang=js"

import "./LiveChat.vue?vue&type=style&index=0&id=278bfece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-278bfece"]])

export default __exports__